var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("header", { staticClass: "topbar" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "headerMenuHamburger",
          on: {
            click: function ($event) {
              return _vm.toggleMenu()
            },
          },
        },
        [
          _c("a", { attrs: { href: "#", title: "Show Menu" } }, [
            _vm._v("Menu"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("nav", { staticClass: "navbar" }, [
        _c("div", { staticClass: "user-info" }, [
          _vm._v("\n        Logged in as: "),
          _c("strong", [_vm._v(_vm._s(_vm.getAuthUser("full_name")))]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "logout",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.logout.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-power-off" }),
              _vm._v(" "),
              _c("span", [_vm._v("Logout")]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "topbar-brand", attrs: { href: "/account/dashboard" } },
      [_c("img", { attrs: { src: "/images/logo.svg" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }